import { ApplicationState } from './../index';

export const GetCardData = (state: ApplicationState) => state.card;
